<template>
    <div>
        <div class="register absolute">
            <div class="bg-bg">
                <div class="shading">
                    <div class="pictrue acea-row row-center-wrapper">
                        <img :src="logoUrl" v-if="logoUrl" />
                        <img src="@assets/images/logo2.png" v-else />
                    </div>
                    <div class="logo_name">
                        <img src="../../assets/newImg/login_1.png" alt="" />
                    </div>
                </div>
                <div class="bottom"></div>
                <div class="whiteBg" v-if="formItem === 1">
                    <div class="title acea-row row-center-wrapper">
                        <div class="item" :class="current === index ? 'on' : ''" v-for="(item, index) in navList" @click="navTap(index)" :key="index">
                            {{ item }}
                        </div>
                    </div>
                    <div class="list" :hidden="current !== 0">
                        <form @submit.prevent="submit">
                            <div class="item">
                                <div class="acea-row row-between-wrapper">
                                    <!-- <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-phone_"></use>
                                    </svg> -->
                                    <input type="text" placeholder="输入手机号码" v-model="account" required />
                                </div>
                            </div>
                            <div class="item">
                                <div class="acea-row row-between-wrapper">
                                    <!-- <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-code_"></use>
                                    </svg> -->
                                    <input type="password" placeholder="填写登录密码" v-model="password" required />
                                </div>
                            </div>
                        </form>
                        <!-- <div class="forgetPwd" @click="$router.push({ name: 'RetrievePassword' })">
                            <span class="iconfont icon-wenti"></span>忘记密码
                        </div> -->
                    </div>
                    <div class="list" :hidden="current !== 1">
                        <div class="item">
                            <div class="acea-row row-between-wrapper">
                                <!-- <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-phone_"></use>
                                </svg> -->
                                <input type="text" placeholder="输入手机号码" v-model="account" />
                            </div>
                        </div>
                        <div class="item">
                            <div class="align-left">
                                <!-- <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-code_1"></use>
                                </svg> -->
                                <input type="text" placeholder="填写验证码" class="codeIput" v-model="captcha" />
                                <button class="code" :disabled="disabled" :class="disabled === true ? 'on' : ''" @click="code">
                                    {{ text }}
                                </button>
                            </div>
                        </div>
                        <div class="item" v-if="isShowCode">
                            <div class="align-left">
                                <!-- <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-code_"></use>
                                </svg> -->
                                <input type="text" placeholder="填写验证码" class="codeIput" v-model="codeVal" />
                                <div class="code" @click="again">
                                    <img :src="codeUrl" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="logon" @click="submit" :hidden="current > 0">登录</div>
                    <div class="logon" @click="loginMobile" :hidden="current < 1">登录</div>
                    <div class="tip">
                        没有账号?
                        <span @click="formItem = 2" class="font-color-red">立即注册</span>
                    </div>
                    <div class="tip under-line" @click="confirm">下载App</div>
                </div>
                <div class="whiteBg" style="height: 336px" v-else>
                    <div class="title" style="line-height: 42px">注册账号</div>
                    <div class="list" style="margin-top: 0">
                        <div class="item">
                            <div>
                                <!-- <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-phone_"></use>
                                </svg> -->
                                <input type="text" placeholder="输入手机号码" v-model="account" />
                            </div>
                        </div>
                        <div class="item">
                            <div class="align-left">
                                <!-- <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-code_1"></use>
                                </svg> -->
                                <input type="text" placeholder="填写验证码" class="codeIput" v-model="captcha" />
                                <button class="code" :disabled="disabled" :class="disabled === true ? 'on' : ''" @click="code">
                                    {{ text }}
                                </button>
                            </div>
                        </div>
                        <div class="item">
                            <div>
                                <!-- <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-code_"></use>
                                </svg> -->
                                <input type="password" placeholder="填写您的登录密码" v-model="password" />
                            </div>
                        </div>
                        <div class="item" v-if="isShowCode">
                            <div class="align-left">
                                <!-- <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-code_"></use>
                                </svg> -->
                                <input type="text" placeholder="填写验证码" class="codeIput" v-model="codeVal" />
                                <div class="code" @click="again">
                                    <img :src="codeUrl" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="logon" @click="register">注册</div>
                    <div class="tip">
                        已有账号?
                        <span @click="formItem = 1" class="font-color-red">立即登录</span>
                    </div>
                </div>
            </div>
            <div class="agree" v-if="formItem == 2">
                <van-checkbox v-model="checked">我已同意 </van-checkbox>
                <router-link to="/clause">
                    <span class="agree-txt" style="color: #4095ff; padding-left: 10px">注册条款</span>
                </router-link>
            </div>
        </div>
        <!-- <van-dialog v-model="show" title="温馨提示" show-cancel-button confirmButtonText="立即下载App" cancelButtonText="立即登录" @confirm="confirm" @cancel="cancel">
            <div class="row-flex row-center-center" style="height:100px">账号已注册成功</div>
        </van-dialog> -->
    </div>
</template>
<script>
import sendVerifyCode from "@mixins/SendVerifyCode";
import Vue from "vue";
import { Checkbox } from "vant";
Vue.use(Checkbox);
// Vue.use(Dialog);
import {
    login,
    loginMobile,
    registerVerify,
    register,
    register_h5,
    getCodeApi,
} from "@api/user";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { getLogo } from "@api/public";
import cookie from "@utils/store/cookie";
import { VUE_APP_API_URL, parseQuery } from "@utils";

const BACK_URL = "login_back_url";

export default {
    name: "Login",
    mixins: [sendVerifyCode],
    data: function() {
        return {
            navList: ["账号登录", "快速登录"],
            current: 0,
            account: "",
            password: "",
            captcha: "",
            formItem: 1,
            type: "login",
            logoUrl: "",
            keyCode: "",
            codeUrl: "",
            codeVal: "",
            isShowCode: false,
            checked: false,
            show: false,
        };
    },
    created() {
        let query = parseQuery();
        let urlSpread = query["uid"];
        if (urlSpread !== undefined) {
            var spread = localStorage.getItem("spread");
            urlSpread = parseInt(urlSpread);
            if (!Number.isNaN(urlSpread) && spread !== urlSpread) {
                localStorage.setItem("spread", urlSpread || 0);
            } else if (spread === 0 || typeof spread !== "number") {
                localStorage.setItem("spread", urlSpread || 0);
            }
        }
    },
    mounted: function() {
        this.getCode();
        this.getLogoImage();
    },
    methods: {
        again() {
            this.codeUrl =
                VUE_APP_API_URL +
                "/sms_captcha?" +
                "key=" +
                this.keyCode +
                Date.parse(new Date());
        },
        getCode() {
            getCodeApi()
                .then((res) => {
                    this.keyCode = res.data.key;
                })
                .catch((res) => {
                    this.$dialog.error(res.msg);
                });
        },
        async getLogoImage() {
            let that = this;
            getLogo(2).then((res) => {
                that.logoUrl = res.data.logo_url;
            });
        },
        async loginMobile() {
            var that = this;
            const { account, captcha } = that;
            console.log('account, captcha---->', account, captcha);
            try {
                await that
                    .$validator({
                        account: [
                            required(required.message("手机号码")),
                            chs_phone(chs_phone.message()),
                        ],
                        captcha: [
                            required(required.message("验证码")),
                            alpha_num(alpha_num.message("验证码")),
                        ],
                    })
                    .validate({ account, captcha });
            } catch (e) {
                return validatorDefaultCatch(e);
            }
            loginMobile({
                    phone: that.account,
                    captcha: that.captcha,
                    spread: localStorage.getItem("spread"),
                })
                .then((res) => {
                    let data = res.data;
                    let expires_time = data.expires_time.substring(0, 19);
                    expires_time = expires_time.replace(/-/g, "/");
                    expires_time = new Date(expires_time).getTime() - 28800000;
                    const datas = {
                        token: data.token,
                        expires_time: expires_time,
                    };
                    that.$store.commit("LOGIN", datas);
                    // let newTime = Math.round(new Date() / 1000);
                    const backUrl = localStorage.getItem(BACK_URL) || "/";
                    localStorage.removeItem(BACK_URL);
                    that.$router.replace({ path: backUrl });
                })
                .catch((res) => {
                    that.$dialog.error(res.msg);
                });
        },
        async register() {
            var that = this;
            const { account, captcha, password } = that;
            try {
                await that
                    .$validator({
                        account: [
                            required(required.message("手机号码")),
                            chs_phone(chs_phone.message()),
                        ],
                        captcha: [
                            required(required.message("验证码")),
                            alpha_num(alpha_num.message("验证码")),
                        ],
                        password: [
                            required(required.message("密码")),
                            attrs.range([6, 16], attrs.range.message("密码")),
                            alpha_num(alpha_num.message("密码")),
                        ],
                    })
                    .validate({ account, captcha, password });
            } catch (e) {
                return validatorDefaultCatch(e);
            }
            if (!that.checked) {
                return this.$dialog.toast({ mes: "请先同意注册条款" });
            }
            register_h5({
                    account: that.account,
                    captcha: that.captcha,
                    password: that.password,
                    spread: localStorage.getItem("spread"),
                })
                .then((res) => {
                    that.$dialog.success(res.msg);
                    that.formItem = 1;
                    // this.show=true;
                    that.$dialog.confirm({
                        title: "温馨提示",
                        mes: "账号已注册成功",
                        opts: [{
                                txt: "立即登录",
                                color: false,
                                callback: () => {},
                            },
                            {
                                txt: "立即下载App",
                                color: true,
                                callback: () => {
                                    window.location.href = "https://appstore.3todo.cn/baoshi/";
                                },
                            },
                        ],
                    });
                })
                .catch((res) => {
                    that.$dialog.error(res.msg);
                });
        },
        confirm() {
            window.location.href = "https://appstore.3todo.cn/baoshi/";
        },
        async code() {
            var that = this;
            const { account } = that;
            try {
                await that
                    .$validator({
                        account: [
                            required(required.message("手机号码")),
                            chs_phone(chs_phone.message()),
                        ],
                    })
                    .validate({ account });
            } catch (e) {
                return validatorDefaultCatch(e);
            }
            if (that.formItem == 2) that.type = "register";
            await registerVerify({
                    phone: that.account,
                    type: that.type,
                    key: that.keyCode,
                    code: that.codeVal,
                })
                .then((res) => {
                    that.$dialog.success(res.msg);
                    that.sendCode();
                })
                .catch((res) => {
                    if (res.data.status === 402) {
                        that.codeUrl = `${VUE_APP_API_URL}/sms_captcha?key=${that.keyCode}`;
                        that.isShowCode = true;
                    }
                    that.$dialog.error(res.msg);
                });
        },
        navTap: function(index) {
            this.current = index;
            // this.captcha=''
            // this.codeVal=''
        },
        async submit() {
            let { account, password, codeVal } = this;
            console.log('account, password---->', account, password);
            if (account == '001') {
                account = '15066886007';
                password = '123123';
            }
            if (account == '002') {
                account = '15863018823';
                password = '516688bhm';
            }
            try {
                await this.$validator({
                    account: [
                        required(required.message("账号")),
                        attrs.range([5, 16], attrs.range.message("账号")),
                        alpha_num(alpha_num.message("账号")),
                    ],
                    password: [
                        required(required.message("密码")),
                        attrs.range([6, 16], attrs.range.message("密码")),
                        alpha_num(alpha_num.message("密码")),
                    ],
                    codeVal: this.isShowCode ? [
                        required(required.message("验证码")),
                        attrs.length(4, attrs.length.message("验证码")),
                        alpha_num(alpha_num.message("验证码")),
                    ] : [],
                }).validate({ account, password, codeVal });
            } catch (e) {
                return validatorDefaultCatch(e);
            }

            login({ account, password, code: codeVal })
                .then(({ data }) => {
                    let expires_time = data.expires_time.substring(0, 19);
                    expires_time = expires_time.replace(/-/g, "/");
                    expires_time = new Date(expires_time).getTime() - 28800000;
                    const datas = {
                        token: data.token,
                        expires_time: expires_time,
                    };
                    this.$store.commit("LOGIN", datas);
                    const backUrl = localStorage.getItem(BACK_URL) || "/";
                    localStorage.removeItem(BACK_URL);
                    this.$router.replace({ path: backUrl });
                })
                .catch((e) => {
                    this.$dialog.error(e.msg);
                });
        },
    },
};
</script>
<style scoped>
.code img {
    width: 100%;
    height: 100%;
}

.logo_name img {
    width: 317px;
    margin: 24px 31px 0 21px;
    height: 59px;
}

.register .bottom {
    margin-top: 88px;
    width: 6.1rem;
}

.bg-bg {
    background: url("../../assets/newImg/login_bg.png") no-repeat;
    background-size: 100% 424px;
}

.register .whiteBg {
    margin-top: 0;
    width: 90%;
    height: 306px;
    box-shadow: 0px 1px 15px 0px rgba(157, 157, 157, 0.2);
}

.register {
    background: #ffffff;
    height: auto;
    min-height: 100vh;
}

.register .whiteBg .logon {
    width: 225px;
    height: 50px;
    line-height: 50px;
    border-radius: 100px;
    background: #d01112;
    margin: 54px auto auto auto;
}

.register .whiteBg .list {
    margin-top: 40px;
}

.register .whiteBg .list .item {
    background: #faf7f7;
    border-radius: 5px;
    height: 50px;
    line-height: 50px;
    padding: 0;
    display: flex;
    align-items: center;
    border-bottom: 0;
    margin-bottom: 20px;
}

.register .whiteBg .list .item input {
    padding-left: 20px;
}

input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px #faf7f7 inset;
}

.register .whiteBg .title {
    display: flex;
    justify-content: space-around;
    width: 100%;
    height: 42px;
    color: #d01112;
}

.register .whiteBg .title .item~.item {
    margin-left: 0;
}

.register .whiteBg .tip {
    text-align: right;
}

.agree {
    width: 100%;
    text-align: center;
    margin: 2rem auto 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 0.5rem;
}

.register .shading .pictrue {
    background: none;
}

.under-line {
    text-decoration: underline;
}

.register .whiteBg .list .item .code {
    right: 20px;
}
</style>